import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { ActiviteModel } from 'src/app/shared/models/simple-types/activite.model';
import { ActiviteService } from 'src/app/shared/services/simple/activite.service';
import { ModalAddActiviteComponent } from 'src/app/shared/components/modals/modal-add-activite/modal-add-activite.component';
import { ModalStructureActiviteComponent } from 'src/app/shared/components/modals/modal-structure-activite/modal-structure-activite.component';


@Component({
  selector: 'app-gestion-activite',
  templateUrl: './gestion-activite.component.html',
  styleUrls: ['./gestion-activite.component.scss']
})
export class GestionActiviteComponent {

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();
  idSociete: number;
  mySubscription: any;
  result = false;
  loading = false;
  selectedAction: ActiviteModel;
  displayedColumns: string[] = ['code', 'libelle', 'action'];
  dataSource: ActiviteModel[];
  matDataSource = new MatTableDataSource<ActiviteModel>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  activites: ActiviteModel[] = [];
  droitLevel = 0;
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private comp: TrieTabService,
    private activiteService: ActiviteService,
    private toastrService: ToastrService,
    private gestionReferentielComponent: GestionReferentielComponentService
  )
  {
    this.idSociete = 1;
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'libelle';
    this.matDataSource.paginator = this.paginator;
    this.loadPage();
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateActiviteFormGroup();
    const dialogRef = this.dialog.open(ModalAddActiviteComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        form,
        activites: this.activites,
        result: this.result
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.onUpdated.emit(true);
      if (result) {
        this.loadPage();
      }
    });
  }

  onModify(activite: ActiviteModel): void {
    const form = this.gestionReferentielComponent.getEditActiviteFormGroup(activite);
    const dialogRef = this.dialog.open(ModalStructureActiviteComponent, {
        autoFocus: false,
        disableClose: true,
        maxHeight: '90vh',
        data: {
          form,
          activite,
          activites: this.activites,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        this.loadPage();
      });
  }


  onDelete(activite: ActiviteModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression du l\'activité',
        message: 'Êtes-vous sur de vouloir supprimer cette activite ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.activiteService.delete(activite.id).subscribe((response: ActiviteModel) => {
          this.toastrService.success('L\'activite a bien été supprimée');
          this.loadPage();
        });
      }
    });
  }

  orderUsers(activites: ActiviteModel[]): ActiviteModel[] {
    activites = activites.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return activites;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    this.activiteService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<ActiviteModel>) => {
      if (query.objets != null) {
        this.activites = query.objets;
      } else {
        this.activites = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<ActiviteModel>(this.activites);
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }

}


